import { useGetUserClaimGroupAbilities } from '@rd-web-markets/market/dist/userAbilities'
import { Loading } from '@rd-web-markets/shared/dist/util';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

/**
 * The logic - it conditionally renders <></> is put inside of the button component
 * because its based on the user abilities, which are fetched with a hook, based on the claim group id
 * @param {*} param0 
 * @returns 
 */
export default function ClaimGroupsListClientCreateProjectButton({ claimGroup, loading }) {
  const { t } = useTranslation();

  const user = useSelector((state) => state.auth.user)
  const userClaimGroupAbilities = useGetUserClaimGroupAbilities({ user, claimGroup })

  if (loading) return <Loading />
  if (!userClaimGroupAbilities.pages.any.canCreateNewProjects) {
    return <></>
  }

  return <>
    <Button
      size='md'
      as={Link}
      className='claim-group-list-view-button'
      to={`/${user.account_type}/companies/${claimGroup.company_id}/${claimGroup.id}/create_new_project?step`}
    >
      {t('create_new_project')}
    </Button>
  </>
}
